import { FileInput, Show, SimpleShowLayout } from "react-admin";

const VoucherShow = () => (
  <Show>
    <SimpleShowLayout>
      <FileInput source="img" label="img" />
    </SimpleShowLayout>
  </Show>
);

export default VoucherShow;
